export const REQUEST_MENU = 'app/Menu/REQUEST_MENU';
export const RECEIVE_MENU = 'app/Menu/RECEIVE_MENU';
export const REQUEST_SECTION = 'app/Menu/REQUEST_SECTION';
export const RECEIVE_SECTION = 'app/Menu/RECEIVE_SECTION';
